// Swatch dropdown 
function initializeSwatchEvents() {
    $('.color-swatch-box').click(function() {
        const nextElement = $(this).next('.grid-product__swatches');
        
        if ($('.size-swatch.active').length) {
            $('.size-swatch.active').slideUp().removeClass('active');
        }

        $('.grid-product__swatches.active').not(nextElement).slideUp().removeClass('active');
        
        nextElement.slideToggle({
            start: function() {
                $(this).css('display', 'block');
                if ($(window).width() < 767) {
                    $('html').addClass('js-drawer-open-pdp');
                }
            },
            complete: function() {
                $(this).toggleClass('active');
                if (!$(this).hasClass('active') && $(window).width() < 767) {
                    $('html').removeClass('js-drawer-open-pdp');
                }
            }
        });
    });

    $('.grid-product__swatch').click(function() {
        const parentElement = $(this).closest('.grid-product__swatches');
        
        if (parentElement.hasClass('active')) {
            parentElement.slideUp({
                complete: function() {
                    $(this).removeClass('active');
                    if ($(window).width() < 767) {
                        $('html').removeClass('js-drawer-open-pdp');
                    }
                }
            });
        }
    });
}

function initializeVariantEvents() {
    $('.variant__label').click(function() {
        const nextElement = $(this).next('.size-swatch');
        
        if ($('.grid-product__swatches.active').length) {
            $('.grid-product__swatches.active').slideUp().removeClass('active');
        }

        $('.size-swatch.active').not(nextElement).slideUp().removeClass('active');
        
        nextElement.slideToggle({
            start: function() {
                $(this).css('display', 'block');
                if ($(window).width() < 767) {
                    $('html').addClass('js-drawer-open-pdp');
                }
            },
            complete: function() {
                $(this).toggleClass('active');
                if (!$(this).hasClass('active') && $(window).width() < 767) {
                    $('html').removeClass('js-drawer-open-pdp');
                }
            }
        });
    });

    $('.size-swatch').click(function(event) {
        const clickedElement = $(event.target);
        
        if (clickedElement.is('label, input')) {
            $(this).slideUp({
                complete: function() {
                    $(this).removeClass('active');
                    if ($(window).width() < 767) {
                        $('html').removeClass('js-drawer-open-pdp');
                    }
                }
            });
        }
    });
}

function initializeCloseButtonEvent() {
    $('.mobile-box-close,.main-content').click(function() {
        $('.grid-product__swatches.active, .size-swatch.active').slideUp({
            complete: function() {
                $(this).removeClass('active');
                if ($(window).width() < 767) {
                    $('html').removeClass('js-drawer-open-pdp');
                }
            }
        });
    });
}
function initializeSlickSlider(selector, prevBtnSelector, nextBtnSelector) {
  var parentElement = $(selector).closest('.dilutions-section-left');
    // Check if the number of slide items is 3 or more
    if ($(selector).children().length >= 3) {
        // Initialize the Slick slider
        $(selector).slick({
            centerMode: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 300,
            initialSlide: 1,
            dots: false,
            centerPadding: '0px',
            rtl: false,
            appendDots: $('.slick-slider-dots'),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: true
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerPadding: '55px',
                        dots: true
                    }
                }
            ]
        });

        $('.slick-play-pause').click(function() {
            if ($(this).hasClass('play')) {
                $(selector).slick('slickPause');
                $(this).removeClass('play').addClass('pause');
                $(this).find('.play-button').show();
                $(this).find('.pause-button').hide();
            } else {
                $(selector).slick('slickPlay');
                $(this).removeClass('pause').addClass('play');
                $(this).find('.play-button').hide();
                $(this).find('.pause-button').show();
            }
        });

        // Handle custom navigation buttons
        $(prevBtnSelector).click(function () {
            $(selector).slick("slickPrev");
        });

        $(nextBtnSelector).click(function () {
            $(selector).slick("slickNext");
        });

        // Initially disable the previous button
        $(prevBtnSelector).addClass("slick-disabled");

        // Update button states after each slide change
        $(selector).on("afterChange", function () {
            if ($(".slick-prev").hasClass("slick-disabled")) {
                $(prevBtnSelector).addClass("slick-disabled");
            } else {
                $(prevBtnSelector).removeClass("slick-disabled");
            }
            if ($(".slick-next").hasClass("slick-disabled")) {
                $(nextBtnSelector).addClass("slick-disabled");
            } else {
                $(nextBtnSelector).removeClass("slick-disabled");
            }
        });
    }
    else{
      parentElement.addClass('no-slider');
    }
}
function initializeIngredientsSlider(selector, prevBtnSelector, nextBtnSelector) {
    $(selector).slick({
        dots: false,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 1000,
				speed: 300,
        slidesToShow: 4,
        draggable: true,
        slidesToScroll: 4,
        variableWidth: false,
        appendDots: $('.slick-slider-dots-in'),
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    variableWidth: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    variableWidth: true,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: '55px',
                    centerMode: true,
                    dots: true,
                    variableWidth: true
                }
            }
        ]
    });
     // Handle custom navigation buttons
     $(prevBtnSelector).click(function () {
        $(selector).slick("slickPrev");
    });

    $(nextBtnSelector).click(function () {
        $(selector).slick("slickNext");
    });

    // Initially disable the previous button
    $(prevBtnSelector).addClass("slick-disabled");

    // Update button states after each slide change
    $(selector).on("afterChange", function () {
        if ($(".slick-prev").hasClass("slick-disabled")) {
            $(prevBtnSelector).addClass("slick-disabled");
        } else {
            $(prevBtnSelector).removeClass("slick-disabled");
        }
        if ($(".slick-next").hasClass("slick-disabled")) {
            $(nextBtnSelector).addClass("slick-disabled");
        } else {
            $(nextBtnSelector).removeClass("slick-disabled");
        }
    });
    $('.overlay-btn-open').click(function() {
        $(this).closest('.ingredients-section-column').addClass('overlay-active');
    });

    $('.overlay-btn-close').click(function() {
        $(this).closest('.ingredients-section-column').removeClass('overlay-active');
    });

}
function initStickyAddToCart() {
    const $stickyAddToCart = $('.payment-sticky');
    const $productSection = $('.payment-wrapper');

    if ($stickyAddToCart.length && $productSection.length) {
        const productBottom = $productSection.offset().top + $productSection.outerHeight();

        $(window).on('scroll.stickyAddToCart', function() {
            const scrollTop = $(window).scrollTop();

            if (scrollTop > productBottom) {
                if (!$stickyAddToCart.hasClass('active')) {
                    $stickyAddToCart.addClass('active');
                }
            } else {
                if ($stickyAddToCart.hasClass('active')) {
                    $stickyAddToCart.removeClass('active');
                }
            }
        });

        $('.add-to-cart-btn').on('click.stickyAddToCart', function() {
            $stickyAddToCart.removeClass('active');
        });
    }
}

function reinitStickyAddToCart() {
    if ($('.payment-sticky').length) {
        $(window).off('scroll.stickyAddToCart');
        $('.add-to-cart-btn').off('click.stickyAddToCart');
        initStickyAddToCart();
    }
}

$(document).ready(function() {
    if ($('.payment-sticky').length) {
        initStickyAddToCart();
    }
});
function initializeUniqueAccordion(uniqueDomNode) {
  const uniqueButtonEl = uniqueDomNode.querySelector('.accordion-button[aria-expanded]');
  const uniqueContentEl = document.getElementById(uniqueButtonEl.getAttribute('aria-controls'));
  let isUniqueOpen = uniqueButtonEl.getAttribute('aria-expanded') === 'true';

  function toggleUnique(open) {
    if (open === isUniqueOpen) {
      return;
    }

    isUniqueOpen = open;
    uniqueButtonEl.setAttribute('aria-expanded', `${open}`);
    uniqueButtonEl.setAttribute('aria-selected', `${open}`);
    const uniqueAccordionBox = uniqueDomNode;

    if (open) {
      $(uniqueContentEl).slideDown({
        duration: 300,
        complete: function() {
          uniqueContentEl.classList.remove('is-hidden');
          uniqueContentEl.removeAttribute('hidden');
        }
      });
      uniqueButtonEl.closest('.tab_drawer_heading').classList.add('d_active');
      uniqueAccordionBox.classList.add('active');
    } else {
      $(uniqueContentEl).slideUp({
        duration: 300,
        complete: function() {
          uniqueContentEl.classList.add('is-hidden');
          uniqueContentEl.setAttribute('hidden', '');
        }
      });
      uniqueButtonEl.closest('.tab_drawer_heading').classList.remove('d_active');
      uniqueAccordionBox.classList.remove('active');
    }
  }

  function onUniqueButtonClick() {
    toggleUnique(!isUniqueOpen);
  }

  function onUniqueButtonKeydown(event) {
    const uniqueIndex = Array.from(uniqueButtonEl.parentElement.children).indexOf(uniqueButtonEl);
    const uniqueHeaders = Array.from(uniqueButtonEl.parentElement.children);

    switch (event.key) {
      case 'ArrowDown':
        focusNextUniqueTab(uniqueHeaders, uniqueIndex);
        event.preventDefault();
        break;
      case 'ArrowUp':
        focusPreviousUniqueTab(uniqueHeaders, uniqueIndex);
        event.preventDefault();
        break;
      case 'Home':
        focusUniqueTab(uniqueHeaders, 0);
        event.preventDefault();
        break;
      case 'End':
        focusUniqueTab(uniqueHeaders, uniqueHeaders.length - 1);
        event.preventDefault();
        break;
      default:
        break;
    }
  }

  function focusNextUniqueTab(uniqueHeaders, currentIndex) {
    const nextIndex = (currentIndex + 1) % uniqueHeaders.length;
    focusUniqueTab(uniqueHeaders, nextIndex);
  }

  function focusPreviousUniqueTab(uniqueHeaders, currentIndex) {
    const prevIndex = (currentIndex - 1 + uniqueHeaders.length) % uniqueHeaders.length;
    focusUniqueTab(uniqueHeaders, prevIndex);
  }

  function focusUniqueTab(uniqueHeaders, index) {
    uniqueHeaders[index].querySelector('.accordion-button').focus();
  }

  uniqueButtonEl.addEventListener('click', onUniqueButtonClick);
  uniqueButtonEl.addEventListener('keydown', onUniqueButtonKeydown);

  return {
    open: () => toggleUnique(true),
    close: () => toggleUnique(false),
  };
}

function reinitializeAccordions() {
  const uniqueAccordions = document.querySelectorAll('.accordion');
  uniqueAccordions.forEach((uniqueAccordionEl) => initializeUniqueAccordion(uniqueAccordionEl));
};

document.addEventListener('DOMContentLoaded', () => {
  reinitializeAccordions();
});

function initializeCustomTabs(tablistNode) {
  const customTabs = Array.from(tablistNode.querySelectorAll('.tab-link-desk'));
  const customTabPanels = customTabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));

  const firstCustomTab = customTabs[0];
  const lastCustomTab = customTabs[customTabs.length - 1];

  customTabs.forEach((tab, index) => {
    tab.tabIndex = -1;
    tab.setAttribute('aria-selected', 'false');
    tab.addEventListener('keydown', (event) => handleTabKeydown(event, customTabs, customTabPanels, firstCustomTab, lastCustomTab));
    tab.addEventListener('click', (event) => handleTabClick(event, customTabs, customTabPanels));
  });

  updateSelectedTab(firstCustomTab, customTabs, customTabPanels, false);

  function updateSelectedTab(selectedTab, tabs, tabPanels, focus = true) {
    tabs.forEach((tab, index) => {
      if (selectedTab === tab) {
        tab.setAttribute('aria-selected', 'true');
        tab.removeAttribute('tabindex');
        tabPanels[index].classList.remove('is-hidden');
        if (focus) {
          tab.focus();
        }
      } else {
        tab.setAttribute('aria-selected', 'false');
        tab.tabIndex = -1;
        tabPanels[index].classList.add('is-hidden');
      }
    });
  }

  function setPreviousTab(currentTab, tabs, tabPanels, firstTab, lastTab) {
    if (currentTab === firstTab) {
      updateSelectedTab(lastTab, tabs, tabPanels);
    } else {
      const index = tabs.indexOf(currentTab);
      updateSelectedTab(tabs[index - 1], tabs, tabPanels);
    }
  }

  function setNextTab(currentTab, tabs, tabPanels, firstTab, lastTab) {
    if (currentTab === lastTab) {
      updateSelectedTab(firstTab, tabs, tabPanels);
    } else {
      const index = tabs.indexOf(currentTab);
      updateSelectedTab(tabs[index + 1], tabs, tabPanels);
    }
  }

  function handleTabKeydown(event, tabs, tabPanels, firstTab, lastTab) {
    let shouldPreventDefault = false;

    switch (event.key) {
      case 'ArrowLeft':
        setPreviousTab(event.currentTarget, tabs, tabPanels, firstTab, lastTab);
        shouldPreventDefault = true;
        break;

      case 'ArrowRight':
        setNextTab(event.currentTarget, tabs, tabPanels, firstTab, lastTab);
        shouldPreventDefault = true;
        break;

      case 'Home':
        updateSelectedTab(firstTab, tabs, tabPanels);
        shouldPreventDefault = true;
        break;

      case 'End':
        updateSelectedTab(lastTab, tabs, tabPanels);
        shouldPreventDefault = true;
        break;

      default:
        break;
    }

    if (shouldPreventDefault) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  function handleTabClick(event, tabs, tabPanels) {
    updateSelectedTab(event.currentTarget, tabs, tabPanels);
  }
}

// Initialize custom tabs

window.addEventListener('load', function () {
  const customTabLists = document.querySelectorAll('[role=tablist].automatic');
  customTabLists.forEach(tablistNode => {
    initializeCustomTabs(tablistNode);
  });
});
function reinitializeCustomTabs() {
  const customTabLists = document.querySelectorAll('[role=tablist].automatic');
  customTabLists.forEach(tablistNode => {
    initializeCustomTabs(tablistNode);
  });
}
reinitializeCustomTabs();
initializeIngredientsSlider('.ingredients-section-inner', '.in-prev-btn', '.in-next-btn');
initializeSlickSlider('.dilutions-section-left-wrapper', '.prev-btn', '.next-btn');
initializeSwatchEvents();
initializeVariantEvents();
initializeCloseButtonEvent();
function handleArrowClick() {
  $('.product__main-photos-wrapper').on('click', '.slick-arrow', function(event) {
    
    if ($(this).hasClass('slick-disabled')) {
        resetSlickTrackPosition();
        
        event.preventDefault();
        event.stopImmediatePropagation();
    }
  });
}

function resetSlickTrackPosition() {
  $('.product__thumbs .slick-track').css({
    'transform': 'translate3d(0px, 0px, 0px)',
    'transition': 'none'
  });
}

handleArrowClick();



function initializeSlickDotsAccessibility() {
  document.querySelectorAll('.slick-dots li').forEach((li, index) => {
    const button = li.querySelector('button');
    const isActive = li.classList.contains('slick-active');
    
    // Set attributes for <li> element
    li.setAttribute('role', 'presentation');
    
    // Set attributes for <button> element
    button.setAttribute('role', 'tab');
    button.setAttribute('id', `slick-slide${10 + index}`);
    button.setAttribute('aria-controls', `navigation${10 + index}`);
    button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    button.setAttribute('tabindex', isActive ? '0' : '-1');
  });

  // Optional: Add event listeners for click handling if needed
  document.querySelectorAll('.slick-dots button').forEach((button) => {
    button.addEventListener('click', (event) => {
      const currentTab = event.currentTarget;
      const tabs = currentTab.closest('.slick-dots').querySelectorAll('button');

      tabs.forEach((tab) => {
        tab.setAttribute('aria-selected', 'false');
        tab.setAttribute('tabindex', '-1');
        tab.closest('li').classList.remove('slick-active');
      });

      currentTab.setAttribute('aria-selected', 'true');
      currentTab.setAttribute('tabindex', '0');
      currentTab.closest('li').classList.add('slick-active');
      currentTab.focus();
    });
  });
}
function initializeSlickSliderfq(selector, prevBtnSelector, nextBtnSelector) {
  // Initialize the slick slider
  $(selector).slick({
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  // Handle custom navigation buttons
  function handleNavigationButtons() {
    $(prevBtnSelector).click(function () {
      $(selector).slick("slickPrev");
    });

    $(nextBtnSelector).click(function () {
      $(selector).slick("slickNext");
    });

    // Initially disable the previous button
    $(prevBtnSelector).addClass("slick-disabled");

    // Update button states after each slide change
    $(selector).on("afterChange", function () {
      toggleButtonState(selector, prevBtnSelector, nextBtnSelector);
    });
  }

  // Function to toggle button state
  function toggleButtonState(slider, prevButton, nextButton) {
    if ($(slider).find(".slick-prev").hasClass("slick-disabled")) {
      $(prevButton).addClass("slick-disabled");
    } else {
      $(prevButton).removeClass("slick-disabled");
    }

    if ($(slider).find(".slick-next").hasClass("slick-disabled")) {
      $(nextButton).addClass("slick-disabled");
    } else {
      $(nextButton).removeClass("slick-disabled");
    }
  }

  handleNavigationButtons(); // Initialize the button handlers
}
initializeSlickDotsAccessibility();
initializeSlickSliderfq('.frequently-section', '.prev-btn-fq', '.next-btn-fq');
document.addEventListener('DOMContentLoaded', function() {
    let currentProductHandle = null;

    const initialSectionId = document.querySelector('.product-section')?.getAttribute('data-section-id');

    if (!initialSectionId) {
        console.error('Initial section ID not found.');
        return;
    }

    const productContainer = document.querySelector(`#shopify-section-product-template-new`);

    if (!productContainer) {
        console.log(`Container with data-section-id="${initialSectionId}" not found.`);
        return;
    }

    // Attach event listeners to swatch buttons
    function attachEventListeners() {
        const productButtons = document.querySelectorAll('.grid-product__swatch');
        productButtons.forEach(button => {
            button.addEventListener('click', function(event) {
                event.preventDefault();
                const productHandle = this.getAttribute('data-product-handle');
                
                // Debugging: Log productHandle to check its value
                if (!productHandle) {
                    console.error('data-product-handle attribute is missing or invalid.');
                    return;
                }

                console.log('Swatch clicked, productHandle:', productHandle);

                if (productHandle !== currentProductHandle) {
                    updateProduct(productHandle);
                }
            });
        });
    }

    // Update product content when a new swatch is clicked
    function updateProduct(productHandle) {
        const url = `/products/${productHandle}`;
        console.log('Fetching URL:', url);

        fetch(url)
            .then(response => {
                console.log('Response status:', response.status);
                if (!response.ok) {
                    throw new Error(`Network response was not ok: ${response.statusText}`);
                }
                return response.text();
            })
            .then(html => {
                const newDocument = new DOMParser().parseFromString(html, 'text/html');
                const newProductSection = newDocument.querySelector('.product-section');
                const newPdpSections = newDocument.querySelectorAll('.pdp-section');

                if (newProductSection) {
                    productContainer.innerHTML = ''; // Clear existing content

                    // Append new product section
                    productContainer.appendChild(newProductSection.cloneNode(true));

                    // Append all new pdp-sections
                    newPdpSections.forEach(section => {
                        productContainer.appendChild(section.cloneNode(true));
                    });

                    // Update the URL without refreshing the page
                    history.replaceState(null, null, `/products/${productHandle}`);

                    // Set the current product handle to prevent unnecessary re-fetching
                    currentProductHandle = productHandle;

                    // Reattach event listeners and reinitialize features
                    attachEventListeners();
                    reinitializeCustomTabs();
                    initializeSwatchEvents();
                    reinitializeAccordions();
                    initializeVariantEvents();
                    handleArrowClick();
                    fetchCartTotal();
                    initializeSlickDotsAccessibility();
                    initStickyAddToCart();
                    initializeSlickSlider('.dilutions-section-left-wrapper', '.prev-btn', '.next-btn');
                    initializeIngredientsSlider('.ingredients-section-inner', '.in-prev-btn', '.in-next-btn');
                    initializeSlickSliderfq('.frequently-section', '.prev-btn-fq', '.next-btn-fq');
                    theme.init();
                    // Register sections with the theme
                    window.sections = new theme.Sections();
                    //window.SkioPlanPicker = SkioPlanPicker;
                    sections.register('header-section', theme.HeaderSection);
                    sections.register('slideshow-section', theme.SlideshowSection);
                    sections.register('video-section', theme.VideoSection);
                    sections.register('product', theme.Product);
                    sections.register('product-template', theme.Product);
                    sections.register('collection-template', theme.Collection);
                    sections.register('featured-content-section', theme.FeaturedContentSection);
                    sections.register('testimonials', theme.Testimonials);
                    sections.register('instagram', theme.Instagram);
                    sections.register('newsletter-popup', theme.NewsletterPopup);
                    sections.register('fading-images', theme.FadingImages);
                    sections.register('map', theme.Maps);
                    sections.register('blog', theme.Blog);
                    sections.register('photoswipe', theme.Photoswipe);
                } else {
                    console.log('New product section not found in the fetched HTML.');
                }
            })
            .catch(error => {
                console.log('Error fetching product:', error);
            });
    }

    // Initial setup
    attachEventListeners();
});


function initSliderSync() {
    const $mainSliders = $('.product__main-photos-wrapper');
    const $thumbSliders = $('.product__thumbs');
    $mainSliders.slick('refresh');
    $thumbSliders.slick('refresh');
    // Sync the main slider with the thumbnail clicks
    $thumbSliders.on('click', '.slick-slide', function(event) {
        const indeximage = $(this).data('slick-index');

      setTimeout(() => {
        $mainSliders.slick('slickGoTo', indeximage);
      }, 0);
  

        console.log("index",indeximage)
    });

    // Optional: Re-sync after filtering
    $mainSliders.slick('refresh');
    $thumbSliders.slick('refresh');
}


  class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  get relatedProducts() {
    const relatedProductsSectionId = SectionId.getIdForSection(
      SectionId.parseId(this.sectionId),
      'related-products'
    );
    return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
          initializeSlickSliderfq('.product-row', '.prev-btn-fq', '.next-btn-fq');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define('product-recommendations', ProductRecommendations);

const viewAllButton = document.querySelector('.view-all');
if (viewAllButton) {
    viewAllButton.addEventListener('click', function() {
        const targetElement = document.querySelector('#BVRRSearchContainer');
        const offset = 120;
        
        if (targetElement) {
            const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    });
}